import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { ServerResponse } from 'data/types';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'data/root.reducers';

export const API_PATH_TARGET_DOMAIN = '/target-domain';

export const GET_TARGET_DOMAIN_LIST = 'GET_TARGET_DOMAIN_LIST';
export const GET_TARGET_DOMAIN_LIST_PENDING = 'GET_TARGET_DOMAIN_LIST_PENDING';
export const GET_TARGET_DOMAIN_LIST_FULFILLED = 'GET_TARGET_DOMAIN_LIST_FULFILLED';
export const GET_TARGET_DOMAIN_LIST_REJECTED = 'GET_TARGET_DOMAIN_LIST_REJECTED';

export const GET_TARGET_DOMAIN = 'GET_TARGET_DOMAIN';
export const GET_TARGET_DOMAIN_PENDING = 'GET_TARGET_DOMAIN_PENDING';
export const GET_TARGET_DOMAIN_FULFILLED = 'GET_TARGET_DOMAIN_FULFILLED';
export const GET_TARGET_DOMAIN_REJECTED = 'GET_TARGET_DOMAIN_REJECTED';

export const CREATE_TARGET_DOMAIN = 'CREATE_TARGET_DOMAIN';
export const CREATE_TARGET_DOMAIN_PENDING = 'CREATE_TARGET_DOMAIN_PENDING';
export const CREATE_TARGET_DOMAIN_FULFILLED = 'CREATE_TARGET_DOMAIN_FULFILLED';
export const CREATE_TARGET_DOMAIN_REJECTED = 'CREATE_TARGET_DOMAIN_REJECTED';
export const UPDATE_TARGET_DOMAIN = 'UPDATE_TARGET_DOMAIN';
export const UPDATE_TARGET_DOMAIN_PENDING = 'UPDATE_TARGET_DOMAIN_PENDING';
export const UPDATE_TARGET_DOMAIN_FULFILLED = 'UPDATE_TARGET_DOMAIN_FULFILLED';
export const UPDATE_TARGET_DOMAIN_REJECTED = 'UPDATE_TARGET_DOMAIN_REJECTED';
export const DELETE_TARGET_DOMAIN = 'DELETE_TARGET_DOMAIN';
export const DELETE_TARGET_DOMAIN_PENDING = 'DELETE_TARGET_DOMAIN_PENDING';
export const DELETE_TARGET_DOMAIN_FULFILLED = 'DELETE_TARGET_DOMAIN_FULFILLED';
export const DELETE_TARGET_DOMAIN_REJECTED = 'DELETE_TARGET_DOMAIN_REJECTED';

export const SELECT_TARGET_DOMAIN = 'SELECT_TARGET_DOMAIN';
export const GO_TO_TARGET_DOMAIN_CREATE = 'GO_TO_TARGET_DOMAIN_CREATE';
export const GO_TO_TARGET_DOMAIN_EDIT = 'GO_TO_TARGET_DOMAIN_EDIT';
export const GO_TO_TARGET_DOMAIN_VIEW = 'GO_TO_TARGET_DOMAIN_VIEW';
export const GO_TO_TARGET_DOMAIN_LIST = 'GO_TO_TARGET_DOMAIN_LIST';

export enum TargetDomainMenuActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export enum TargetDomainPrivileges {
  View = 'dc_access',
  Edit = 'dc_access',
  Delete = 'dc_access',
}

export interface TargetDomain {
  id: string
  domain: string
  description?: string
}

export interface TargetDomainState {
  entities: TargetDomain[]
  select: TargetDomain[]
  single: TargetDomain | null
  createdId: string | null
}

export interface GetTargetDomainListAction extends AnyAction {
  type: typeof GET_TARGET_DOMAIN_LIST
  payload: AxiosPromise<ServerResponse<TargetDomain>>
}

export interface GetTargetDomainListPendingAction extends AnyAction {
  type: typeof GET_TARGET_DOMAIN_LIST_PENDING
  payload: AxiosResponse<ServerResponse<TargetDomain>>
}
export interface GetTargetDomainListFulfilledAction extends AnyAction {
  type: typeof GET_TARGET_DOMAIN_LIST_FULFILLED
  payload: AxiosResponse<ServerResponse<TargetDomain>>
}

export interface GetTargetDomainRejectedAction extends AnyAction {
  type: typeof GET_TARGET_DOMAIN_REJECTED
  payload: AxiosResponse<ServerResponse<TargetDomain>>
}

export interface GetSingleTargetDomainAction extends AnyAction {
  type: typeof GET_TARGET_DOMAIN
  payload: AxiosPromise<ServerResponse<TargetDomain>>
}

export interface GetSingleTargetDomainPendingAction extends AnyAction {
  type: typeof GET_TARGET_DOMAIN_PENDING
  payload: AxiosResponse<ServerResponse<TargetDomain>>
}
export interface GetSingleTargetDomainFulfilledAction extends AnyAction {
  type: typeof GET_TARGET_DOMAIN_FULFILLED
  payload: AxiosResponse<ServerResponse<TargetDomain>>
}

export interface GetSingleTargetDomainRejectedAction extends AnyAction {
  type: typeof GET_TARGET_DOMAIN_REJECTED
  payload: AxiosResponse<ServerResponse<TargetDomain>>
}

export interface CreateTargetDomainThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}

export interface CreateTargetDomainAction extends AnyAction {
  type: typeof CREATE_TARGET_DOMAIN
  payload: AxiosPromise<ServerResponse<TargetDomain>>
}

export interface CreateTargetDomainPendingAction extends AnyAction {
  type: typeof CREATE_TARGET_DOMAIN_PENDING
  payload: AxiosPromise<ServerResponse<TargetDomain>>
}

export interface CreateTargetDomainFulfilledAction extends AnyAction {
  type: typeof CREATE_TARGET_DOMAIN_FULFILLED
  payload: AxiosResponse<ServerResponse<TargetDomain>>
}

export interface CreateTargetDomainRejectedAction extends AnyAction {
  type: typeof CREATE_TARGET_DOMAIN_REJECTED
  payload: AxiosResponse<ServerResponse<TargetDomain>>
}

export interface UpdateTargetDomainThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}

export interface UpdateTargetDomainAction extends AnyAction {
  type: typeof UPDATE_TARGET_DOMAIN
  payload: AxiosPromise<ServerResponse<TargetDomain>>
}

export interface UpdateTargetDomainFulfilledAction extends AnyAction {
  type: typeof UPDATE_TARGET_DOMAIN_FULFILLED
  payload: AxiosResponse<ServerResponse<TargetDomain>>
}

export interface UpdateTargetDomainRejectedAction extends AnyAction {
  type: typeof UPDATE_TARGET_DOMAIN_REJECTED
  payload: AxiosResponse<ServerResponse<TargetDomain>>
}

export interface DeleteTargetDomainThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}

export interface DeleteTargetDomainAction extends AnyAction {
  type: typeof DELETE_TARGET_DOMAIN
  payload: AxiosPromise<ServerResponse<TargetDomain>>
}

export interface DeleteTargetDomainFulfilledAction extends AnyAction {
  type: typeof DELETE_TARGET_DOMAIN_FULFILLED
  payload: AxiosResponse<ServerResponse<TargetDomain>>
}

export interface DeleteTargetDomainRejectedAction extends AnyAction {
  type: typeof DELETE_TARGET_DOMAIN_REJECTED
  payload: AxiosResponse<ServerResponse<TargetDomain>>
}

export interface SelectTargetDomain extends AnyAction {
  type: typeof SELECT_TARGET_DOMAIN
  payload: TargetDomain[]
}

export type TargetDomainActionTypes =
  GetTargetDomainListAction |
  GetTargetDomainListPendingAction |
  GetTargetDomainListFulfilledAction |
  GetTargetDomainRejectedAction |
  GetSingleTargetDomainAction |
  GetSingleTargetDomainPendingAction |
  GetSingleTargetDomainFulfilledAction |
  GetSingleTargetDomainRejectedAction |
  DeleteTargetDomainAction |
  DeleteTargetDomainFulfilledAction |
  DeleteTargetDomainRejectedAction |
  CreateTargetDomainAction |
  CreateTargetDomainFulfilledAction |
  CreateTargetDomainRejectedAction |
  UpdateTargetDomainAction |
  UpdateTargetDomainFulfilledAction |
  UpdateTargetDomainRejectedAction |
  SelectTargetDomain |
  CreateTargetDomainPendingAction;
